<div class="flex items-start justify-center min-h-screen">
  <div class="mb-4 p-8">
    <p-card [style]="{ width: '50rem', overflow: 'hidden' }">
      <ng-template #header>
        <img alt="Card" class="w-full" height="1" ngSrc="server-error.png" priority width="1.5" />
      </ng-template>
      <ng-template #title> Service Connection Unavailable </ng-template>
      <ng-template #subtitle> We're currently unable to connect to the service. </ng-template>
      <p class="mb-3">
        Please try again in a few minutes. If the issue persists or this is urgent, contact support for immediate
        assistance.
      </p>
    </p-card>
  </div>
</div>
